import { render } from "./DragonKitIntroduction.vue?vue&type=template&id=82e513bc"
const script = {}

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__